// extracted by mini-css-extract-plugin
export default {"label":"gBPqMKsI2QcRGSipLBry"};